import axios, { AxiosRequestConfig } from "axios"

const protocol = window.location.protocol
const slashes = protocol.concat("//")

export const BASE_PATH = slashes.concat(window.location.host)

const HOST =  !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? "http://localhost/servicios/index.php/rest/contador_calorias/" : "https://www.acromax.com.ec/servicios/index.php/rest/contador_calorias/"

//Get
export const get = async (path:string, options?:AxiosRequestConfig, server:string = HOST) => {
    return await axios.get(server+path,setCommonConfigs(options))
            .then( p => p.data || { error: "Sin datos"} as Array<any> | iRespuesta)
            .catch(cathError)
}

//Post
export const post = async (path:string,data?:any,options?:AxiosRequestConfig, server:string = HOST) => {
    return await axios.post(server+path,data,setCommonConfigs(options))
            .then( p => p.data || { error: "Sin datos"} as Array<any> | iRespuesta)
            .catch(cathError)
}

//Put
export const put = async (path:string,data?:any,options?:AxiosRequestConfig, server:string = HOST) => {
    return await axios.put(server+path,data,setCommonConfigs(options))
            .then( p => p.data || { error: "Sin datos"} as Array<any> | iRespuesta)
            .catch(cathError)
}

//Delete
export const del = async (path:string,options?:AxiosRequestConfig, server:string = HOST) => {
    return await axios.delete(server+path,setCommonConfigs(options))
        .then( p => p.data || { error: "Sin datos"} as Array<any> | iRespuesta)
        .catch(cathError)
}

//Captura el error
function cathError(error:any){
    console.log(error)
    if(error && error.response){
        if(error.response.status === 401){
            window.localStorage.clear()
            window.location.href = "/login";
        }
        return error.response.data || { error : "error_servicio" } as iRespuesta
    }else{
        return { error : "error_servicio" } as iRespuesta
    }
}

//Interfaz respuesta
export interface iRespuesta{
    response?: boolean,
    error?: string
    data?: any,
    total?: number
}

//Cabeceras en comun
function setCommonConfigs(options?:AxiosRequestConfig){
    var _options = {} as AxiosRequestConfig
    if(options){
        _options = {...options}
    }
    _options.headers = {..._options.headers}
    return _options
}